import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter, startWith, switchMap, take, tap } from 'rxjs/operators';
import { ProductPicture } from '../../../classes';
import { IProductIdProvider, PRODUCT_ID_PROVIDER } from '../../../interfaces';
import { ProductService } from '../../../services/product.service';

@Component({
  selector: 'app-product-pictures',
  templateUrl: './product-pictures.component.html',
  styleUrls: ['./product-pictures.component.css']
})
export class ProductPicturesComponent implements OnDestroy, OnInit {

  canUpload: boolean = false;
  pictures: ProductPicture[] = [];

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(PRODUCT_ID_PROVIDER) private _productIdProvider: IProductIdProvider,
    private _productService: ProductService
  ) { }

  deletePicture(picture: ProductPicture){
    this._productService.deleteProductPicture(picture.pictureid).subscribe(() => {
      let index = this.pictures.findIndex(x => x === picture);
      if(index > 0) this.pictures.splice(index, 1);
    });
  }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this._productIdProvider.productId$.pipe(startWith(null), filter(x => {
        if(!x){
          this.pictures = [];
          this.canUpload = false;
          return false;
        }
        this.canUpload = true;
        return true;
      }), switchMap(x => this._productService.getAllProductPictures(x))).subscribe((pictures) => {
        this.pictures = pictures;
      })
    ]);
  }

  uploadPictures(e){
    this._productIdProvider.productId$.pipe(take(1)).subscribe((productId: number) => {
      let file = (e.target.files as FileList)[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = ((e) => {
        this._productService.createProductPicture({
          'picturedata': window.btoa(<string>(<any>e.target).result),
          'productid': productId,
          'picturemediatype': file.type
        } as ProductPicture).subscribe({
          next: (picture) => this.pictures = [...this.pictures, picture]
        });
      });
      reader.readAsBinaryString(file);
    });
  }

}
